import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { heroTrash, heroDocument } from '@ng-icons/heroicons/outline';

@Component({
  selector: 'app-file-preview',
  standalone: true,
  providers: [provideIcons({ heroTrash, heroDocument })],
  imports: [CommonModule, NgIconComponent],
  template: `
    <div class="relative w-full h-full" [title]="file.name">
      <div *ngIf="previewUrl" [ngStyle]="{backgroundImage: 'url(' + previewUrl + ')'}" class="w-full h-full bg-contain bg-no-repeat bg-center bg-slate-300 rounded"></div>
      <div *ngIf="!previewUrl" class="flex items-center justify-center w-full h-full bg-contain bg-no-repeat bg-center bg-slate-300 rounded text-white">
          <ng-icon name="heroDocument" size="4em"></ng-icon>
      </div>
      <div class="flex absolute left-0 bottom-0 right-0 bg-slate-600 text-white text-sm px-1 py-0.5 rounded-bl rounded-tr">
        <div class="whitespace-nowrap overflow-hidden text-ellipsis pr-2">{{file.name}}</div>
        <button type="button" role="button" class="ml-auto" (click)="remove.emit(file)"><ng-icon name="heroTrash" class="text-sm"></ng-icon></button>
      </div>
    <div>
  `,
  styles: [
    `:host {
      display: block;
    }`
  ]
})
export class FilePreviewComponent implements OnInit {

  @Input() file!: File;
  previewUrl: string|null|undefined;

  @Output() remove = new EventEmitter<File>();

  async ngOnInit() {
    this.previewUrl = this.getPreviewUrl(this.file);
  }

  getPreviewUrl(file: File) {
    if (!file.type.match(/image.*/))
      return null;

    const blob = new Blob([file]);
    const url = URL.createObjectURL(blob);
    return url;
  }

}
